export default __webpack_public_path__ + "static/media/ProtocolsOverviewPhoto.f86a0564.jpeg";